"use client";

import { useEffect, useState } from "react";
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import moment from "moment";
import TextEditor from "../TextEditor";
import {
  getAdmins,
  getMailId,
  getUser,
  getUserdetails,
} from "../../Localstorage/localstorage";
import Select2 from "../Select2";
import TextEditorAll from "../TextEditorAll";
import uuid from "react-uuid";
import { AXIOS_POST } from "../../server/api/crud";
import { useDispatch, useSelector } from "react-redux";
import {
  setMailMessage,
  setMailMessageItems,
  setMailMessageItemsFilter,
  setMailRooms,
} from "../../redux/mailSlice";
import SelectPatienten from "../SelectPatienten";
import SelectAdmins from "../SelectAdmins";
import { buildEmailData, emailBerichten } from "../../EmailTemplates";
import Swal from "sweetalert2";
import { sendEmail, sendEmailGewoon } from "../../function";

const categories = [
  "Intake formulier (Vragenlijsten)",
  "Pretintake formulier (Vragenlijsten)",
  "Klachternformulier formulier (Vragenlijsten)",
  "Mijn Afspraken",
  "Dashboard",
  "Mijn dagelijkse gezondheidscontrole (eetdagboek)",
  "Mijn Documenten",
  "Mijn Voortuigang",
  "Andere",
];

const RPDrawerMessaging = ({
  messages,
  chatroom,
  open = true,
  setOpen = null,
}) => {
  const dispatch = useDispatch();
  const { mailRooms, mailMessage, command } = useSelector(
    (state) => state.mail
  );

  const user = getUser();
  const userdetails = getUserdetails();
  const { patienten, admins } = useSelector((state) => state.user);

  const gebruikers = user.role == 2 ? admins[0] : patienten[0];
  const personen = user.role == 2 ? admins : patienten;

  const [selected, setSelected] = useState(gebruikers);
  const [formData, setFormData] = useState(null);
  const [category, setCategory] = useState(categories[0]);
  const [mailNewMessage, setNewmailMessage] = useState(null);

  const saveMessage = async () => {
    let messagess = {};
    try {
      const idMessage = uuid(); // Generate unique ID for the mailmessage
      const currentDate = moment().format("YYYY-MM-DD");
      const currentDateTime = moment().format("YYYY-MM-DD HH:mm:ss"); // Correct format

      // Create a base message item (detail) object
      const newItemMessage = {
        ...formData,
        id: uuid(),
        mailmessage_id: command === "insert" ? idMessage : mailMessage?.id,
        author_id: userdetails?.user_id,
        author: userdetails?.full_name,
        avatar: userdetails?.avatar,
        datetime: currentDateTime,
      };

      if (command === "insert") {
        // Create the mailmessage (master) object
        const newMailMessage = {
          id: idMessage, // Use the generated ID for the mailmessage
          subject: mailNewMessage?.subject,
          sender: user.role == 2 ? userdetails?.full_name : selected?.full_name,
          sender_id: user.role == 2 ? userdetails?.user_id : selected?.user_id,
          receiver:
            user.role == 1 ? userdetails?.full_name : selected.full_name,
          receiver_id: user.role == 1 ? userdetails?.user_id : selected.user_id,
          category: category,
          date: currentDate,
          datetime: currentDateTime,
          status: "Send",
          preview: "",
        };

        const responseCombined = await AXIOS_POST(
          `mailbox/conversation/start`,
          { thread: newMailMessage, item: newItemMessage }
        );

        if (responseCombined?.status === 200 || responseCombined?.status === 201) {
          dispatch(setMailMessage(newMailMessage));
          dispatch(setMailRooms(newMailMessage));
          dispatch(setMailMessageItemsFilter(newItemMessage));
          dispatch(setMailMessageItems(newItemMessage));
          messagess = newMailMessage;
        } else {
          console.error("Error starting conversation:", responseCombined);
        }
      } else {
        // If updating, directly insert the message item
        const responseNewItemMessage = await AXIOS_POST(
          `mailbox/message`,
          newItemMessage
        );

        messagess = mailMessage;

        if (responseNewItemMessage?.status) {
          dispatch(setMailMessageItemsFilter(newItemMessage));
          dispatch(setMailMessageItems(newItemMessage));
        } else {
          console.error("Error inserting message item:");
        }
        dispatch(setMailMessage(mailMessage));
      }

      const otherUserId = (currentUserId) => {
        return messagess?.receiver_id === currentUserId
        ? messagess?.sender_id
        : messagess?.sender_id === currentUserId
        ? messagess?.receiver_id
        : null;
      }
        
      const klant = personen.find(
        (el) => otherUserId(el?.user_id)
      );

      if (userdetails?.email) {
        if (klant?.email) {
          const emailData = buildEmailData({
            from_name: "RepeatConnect",
            title: `Hallo , ${klant?.full_name} U heeft een bericht ontvangen`,
            receiver_email: klant?.email,
            receiver: klant?.full_name,
            sender: userdetails.full_name,
            body: formData?.body,
          });

          const emailHtml = emailBerichten(emailData);
    

           sendEmailGewoon("template_qdoh9mv", {
            message_html: emailHtml,
            title: emailData?.title,
            receiver_email: emailData?.receiver_email,
          });

        } else {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: `Gelieve een e-mailadres toe te voegen. Ga naar Profielinstellingen en voeg uw e-mailadres toe.`,
            showConfirmButton: false,
            timer: 3500,
          });
        }
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: `De klant heeft nog geen e-mailadres toegevoegd aan zijn profielinstellingen.`,
          showConfirmButton: false,
          timer: 3500,
        });
      }

      // Reset form data after successful insertions
      setFormData({});
      setNewmailMessage({});
      setOpen(false);
    } catch (error) {
      console.error("Error saving message:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewmailMessage((prev) => ({ ...prev, [name]: value }));
  };
  const replyTargetName =
    mailMessage?.sender_id === userdetails?.user_id
      ? mailMessage?.receiver
      : mailMessage?.sender;

  return (
    <Dialog open={open} onClose={setOpen} className="relative z-50">
      <DialogBackdrop className="fixed inset-0 bg-black/45 backdrop-blur-[1px]" />
      <div className="fixed inset-0 overflow-y-auto p-2 sm:p-4 lg:p-6">
        <div className="flex min-h-full items-center justify-center">
          <DialogPanel
            transition
            className="pointer-events-auto relative flex h-[90dvh] w-full max-w-4xl transform flex-col overflow-hidden rounded-2xl border border-wa-border bg-wa-panel text-wa-text shadow-2xl transition-all duration-300 data-[closed]:translate-y-2 data-[closed]:opacity-0 sm:h-[min(86dvh,760px)] sm:rounded-3xl"
          >
              <button
                type="button"
                onClick={() => setOpen(false)}
                className="absolute right-3 top-3 z-10 rounded-xl border border-wa-border bg-wa-panel2/90 p-1.5 text-wa-muted shadow-sm transition hover:bg-wa-hover hover:text-wa-text focus:outline-none focus:ring-2 focus:ring-wa-accent sm:right-4 sm:top-4"
              >
                <span className="absolute -inset-2.5" />
                <span className="sr-only">Close panel</span>
                <XMarkIcon aria-hidden="true" className="h-6 w-6" />
              </button>
              <div className="flex min-h-0 flex-1 flex-col">
                {command == "insert" && (
                  <div className="border-b border-wa-border bg-wa-panel2/55 px-4 py-2.5 pr-14 sm:px-5 sm:py-3 sm:pr-16">
                    <DialogTitle className="text-sm font-semibold text-wa-text sm:text-base">
                      Nieuw bericht
                    </DialogTitle>
                    <p className="mt-0.5 text-[11px] text-wa-muted sm:text-xs">
                      {chatroom?.author ? `Aan ${chatroom.author}` : "Nieuwe conversatie"}{" "}
                      {chatroom?.subject ? `- ${chatroom.subject}` : ""}
                    </p>

                    <div className="mt-2.5 space-y-2.5">
                      <div className="grid grid-cols-1 gap-2 md:grid-cols-12 md:items-end">
                        <div className="md:col-span-6">
                          <label className="mb-1 block text-[11px] font-medium uppercase tracking-wide text-wa-muted">
                            {user?.role == 1 ? "Patiënt" : "Specialist"}
                          </label>
                          <div className="w-full">
                            {user?.role == 2 && admins?.length > 0 && (
                              <SelectAdmins
                                selected={selected ? selected : admins[0]}
                                setSelected={setSelected}
                                data={admins}
                              />
                            )}
                            {user?.role == 1 && patienten?.length > 0 && (
                              <SelectPatienten
                                selected={selected ? selected : patienten[0]}
                                setSelected={setSelected}
                                data={patienten}
                              />
                            )}
                          </div>
                        </div>

                        <div className="hidden md:col-span-6 md:flex md:justify-end md:self-start">
                          <span className="rounded-md border border-wa-border bg-wa-panel px-2 py-1 text-[11px] text-wa-muted">
                            {moment().locale("nl-be").format("HH:mm")}
                          </span>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 gap-2 md:grid-cols-12 md:items-end">
                        <div className="md:col-span-4">
                          <label
                            htmlFor="category"
                            className="mb-1 block text-[11px] font-medium uppercase tracking-wide text-wa-muted"
                          >
                            Categorie
                          </label>
                          <select
                            id="category"
                            name="category"
                            defaultValue={category}
                            onChange={(e) => setCategory(e.target.value)}
                            className="block w-full rounded-xl border border-wa-border bg-wa-panel px-3 py-2 pr-10 text-wa-text ring-1 ring-inset ring-wa-border/50 focus:border-wa-accent focus:ring-2 focus:ring-wa-accent/35 sm:text-sm sm:leading-6"
                          >
                            {categories.map((category, index) => (
                              <option key={index}>{category}</option>
                            ))}
                          </select>
                        </div>

                        <div className="md:col-span-8">
                          <label className="mb-1 block text-[11px] font-medium uppercase tracking-wide text-wa-muted">
                            Subject
                          </label>
                          <div className="flex w-full rounded-xl border border-wa-border bg-wa-panel shadow-sm ring-1 ring-inset ring-wa-border/50 focus-within:border-wa-accent focus-within:ring-2 focus-within:ring-wa-accent/35">
                            <input
                              type="text"
                              name="subject"
                              placeholder="Onderwerp van je bericht"
                              value={mailNewMessage?.subject}
                              onChange={handleChange}
                            className="block h-[38px] flex-1 border-0 bg-transparent py-2 pl-3 text-wa-text placeholder:text-wa-muted focus:ring-0 sm:text-sm sm:leading-6"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {command != "insert" && (
                  <div className="border-b border-wa-border bg-wa-panel2/55 px-4 py-2.5 pr-14 sm:px-6 sm:py-3 sm:pr-16">
                    <p className="text-[10px] font-medium uppercase tracking-wider text-wa-muted">
                      Antwoord
                    </p>
                    <DialogTitle className="mt-0.5 text-sm font-semibold leading-5 text-wa-text sm:text-[15px]">
                      Bericht beantwoorden aan patiënt{" "}
                      <span className="text-wa-accent">
                        {replyTargetName || "onbekend"}
                      </span>
                    </DialogTitle>
                    <p className="mt-0.5 text-[11px] text-wa-muted sm:text-xs">
                      Je antwoord wordt verzonden in dezelfde conversatie.
                    </p>
                  </div>
                )}
                <div className="min-h-0 flex-1 px-3 pb-3 pt-2.5 sm:px-5 sm:pb-4">
                  <TextEditorAll
                    value={formData?.body}
                    editorKey={"body"}
                    setValue={setFormData}
                    p_height={command == "insert" ? "clamp(260px, 40dvh, 520px)" : "clamp(380px, 62dvh, 760px)"}
                    key={"opmerking"}
                  />
                </div>
                <div className="border-t border-wa-border bg-wa-panel2/60 px-3 py-3 sm:px-6 sm:py-4">
                  <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
                    <button
                      type="button"
                      onClick={() => setOpen(false)}
                      className="h-10 rounded-xl border border-wa-border bg-wa-panel px-4 py-2 text-sm font-semibold text-wa-text shadow-sm transition hover:bg-wa-hover sm:min-w-[9rem]"
                    >
                      Annuleer
                    </button>
                    <button
                      onClick={saveMessage}
                      type="submit"
                      className="h-10 rounded-xl bg-wa-accent px-4 py-2 text-sm font-semibold text-wa-onaccent shadow-sm transition hover:bg-wa-accentdeep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-wa-accent sm:min-w-[9rem]"
                    >
                      Opslaan
                    </button>
                  </div>
                </div>
              </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default RPDrawerMessaging;
